import {
  DataWorkshopEntityRaw,
  dataWorkshopEntityRaw,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataWorkshopGetResponseDTO {
  private static validation = Validate.compile(
    DataWorkshopGetResponseDTO.validationSchema()
  );

  constructor(readonly data: DataWorkshopGetResponseDTORaw) {
    Validate.assert(DataWorkshopGetResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['dataWorkshop'],
      properties: {
        dataWorkshop: dataWorkshopEntityRaw,
      },
    };
  }
}

interface DataWorkshopGetResponseDTORaw {
  dataWorkshop: DataWorkshopEntityRaw;
}
